<button (click)="heatmapService.toggleOverlay()">
    {{ (heatmapService.isEnabled | async) ? "Disable" : "Enable" }} heatmap overlay
</button>

<div #heatMapFrame *ngIf="heatmapService.isEnabled | async" class="overlay">
    <svg id="heatMap"></svg>
</div>
